import script from "./CloudflareDDns.vue?vue&type=script&setup=true&lang=js"
export * from "./CloudflareDDns.vue?vue&type=script&setup=true&lang=js"

import "./CloudflareDDns.vue?vue&type=style&index=0&id=34682d91&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34682d91"]])

export default __exports__